import React from "react";

export default class HowToGuidesImage extends React.Component 
{
    constructor(props)
    {
        super(props);

        if(!this.props.hide && this.props.code === 'dumpster')
        {   
            this.requestImageFile = require.context('../images/homepage', true);
            
            this.posts = [
                {
                    title: 'Dumpster Rental Price Guide: How to Lower Your Cost to Rent a Dumpster',
                    url: '/blog/roll-off-dumpster-prices',
                    image:
                    {
                        alt: 'how to get a cheap dumpster',
                        path: './howto-1.jpg'
                    }
                },
                {
                    title: 'The Ultimate Guide to Dumpster Sizes',
                    url: '/blog/the-ultimate-guide-to-dumpster-sizes',
                    image:
                    {
                        alt: 'common roll-off dumpster sizes',
                        path: './howto-2.jpg'
                    }
                },
                {
                    title: 'Dumpster Rental 101: How to Rent a Dumpster',
                    url: '/blog/dumpster-rental-101',
                    image:
                    {
                        alt: 'dumpster rental guide',
                        path: './howto-3.jpg'
                    }
                },
                {
                    title: 'Dumpster Rental Terms and Conditions: A Closer Look at the Fine Print',
                    url: '/blog/dumpster-rental-terms-and-conditions-a-closer-look-at-the-fine-print',
                    image:
                    {
                        alt: 'reading every last detail',
                        path: './howto-4.jpg'
                    }
                },
                {
                    title: 'Rent a Dumpster or Hire a Junk Removal Company?',
                    url: '/blog/rent-a-dumpster-or-hire-a-junk-removal-company',
                    image:
                    {
                        alt: 'Comparing junk removal service with renting a dumpster',
                        path: './woman-sorting-through-household-junk.jpg'  // './howto-5.jpg'
                    }
                }
                ,
                {
                    title: "Commercial Dumpster Service Guide for Business Owners",
                    url: "/blog/commercial-dumpster-service",
                    image:
                    {
                        alt: "blue dumpster being emptied into a dump truck",
                        path: './commercial_dumpster_service_guide.png'
                    }
                }
            ]
        }            
    }
    
    render() 
    {    
        if(this.props.hide || this.props.code !== 'dumpster')
        {
            return( <></> )
        }
        
        return (
            <div className="container-fuild how-to-guides-image">   
                <div class="container"> 
                    <div className="row m-0">  
                        <h2 className="col-12 text-center">How-To Guides</h2>            
                        <div className="articles">
                            <div className="row" style={{gap: '20px'}}>
                            {
                                this.posts.map(post =>
                                {                                                 
                                    return(
                                        <div className="articleContainer" style={{background: `url(${this.requestImageFile(post.image.path)?.default})`}}>
                                            <a href={post.url} className="article" >
                                                {/* <div className="image">
                                                    <img src={this.requestImageFile(post.image.path)?.default} alt={post.image.alt} />
                                                </div> */}
                                                <div className="text"><span>{post.title}</span></div>
                                            </a>
                                        </div>
                                    )
                                })
                            }
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};